<div class="loginMainContainer">
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="loginBlock">
    @if (showLogo()) {
      <ng-lottie [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>
    }

    <div class="form-content" [class.visible]="showLoginForm()">
      <input
        type="text"
        id="username"
        [placeholder]="'auth.login.username' | translate"
        formControlName="username"
        class="form-control"
        aria-label="Small"
        aria-describedby="inputGroup-sizing-sm"
        autocomplete="username"
      />
      <div class="passwordField">
        <input
          [type]="showPassword() ? 'text' : 'password'"
          id="password"
          [placeholder]="'auth.login.password' | translate"
          formControlName="password"
          class="form-control"
          aria-label="Small"
          aria-describedby="inputGroup-sizing-sm"
          autocomplete="current-password"
        />
        <button
          type="button"
          class="passwordToggle"
          [attr.aria-label]="(showPassword() ? 'common.labels.hidePassword' : 'common.labels.showPassword') | translate"
          [attr.aria-pressed]="showPassword()"
          [attr.title]="(showPassword() ? 'common.labels.hidePassword' : 'common.labels.showPassword') | translate"
          (click)="togglePasswordVisibility()"
        >
          <i class="bi" [class.bi-eye]="!showPassword()" [class.bi-eye-slash]="showPassword()" aria-hidden="true"></i>
        </button>
      </div>
      <a [routerLink]="['/forgot-password']">{{ 'auth.login.forgotPassword' | translate }}</a>
      <button type="submit" class="formButton validate" [disabled]="loginForm.invalid">
        {{ 'auth.login.loginButton' | translate }}
      </button>
      <button type="button" class="formButton anonymous" [disabled]="isAnonymousLoading()" (click)="onAnonymousLogin()">
        @if (isAnonymousLoading()) {
          <span>{{ 'common.labels.loading' | translate }}</span>
        } @else {
          <span>{{ 'auth.login.anonymousButton' | translate }}</span>
        }
      </button>
      <div>
        {{ 'auth.login.noAccount' | translate }}
        <a [routerLink]="['/signup']">{{ 'auth.login.signupLink' | translate }}</a>
      </div>
    </div>
  </form>
</div>
